export default "__VITE_ASSET__DybMvjHA__"